import {
    Button,
    Grid,
    Typography
}                      from "@mui/material";
import {
    useEffect,
    useRef,
    useState
}                      from "react";
import {
    AddBassin,
    Bassin,
    BassinDetail,
    DeactivateBassinCommand,
    Delete,
    IGStyle,
    UpdateBassin
} from "../../constants";
import {useZINContext} from "../../context/ZinContextProvider";
import {submitObject}  from "../../util";

const BassinBlock = () =>
{
    const {
        poolDetails,
        setActivePage,
        setPoolDetails,
        poolDSLFilter,
        setPoolDSLFilter,
        refreshResource, setRefreshResource,
        setFormData,
        setModalVisible,
        setModalAction, setAlertVisible, setAlertText,setDeleteCallback
    } = useZINContext()

    const RMRef = useRef<any>()
    const RDRef = useRef<any>()
    const [detailStatus, setDetailStatus] = useState<any>(false)
    const [detailRecord, setDetailRecord] = useState<any>("")

    useEffect(() =>
    {
        RMRef.current?.addEventListener('recordSelected', (event: any) =>
        {
            setFormData(event.detail.record)
            setDetailStatus(true)
            setDetailRecord(event.detail.recordId)
        })
    }, [])

    useEffect(() =>
    {
        switch (refreshResource)
        {
            case Bassin:
                setTimeout(() => RMRef.current?.refresh(), 1000)
                break
            case BassinDetail:
                setTimeout(() => RDRef.current?.refresh(), 1000)
                break
        }
        setRefreshResource("")
    }, [refreshResource]);

    function ResetDetailStatus()
    {
        setRefreshResource(Bassin)
        setDetailStatus(false)
    }

    function BassinToevoegen()
    {
        setFormData(undefined)

        setModalVisible(true)
        setModalAction(AddBassin)
    }

    function BassinBewerken()
    {
        setFormData(RDRef.current?.data)

        setModalVisible(true)
        setModalAction(UpdateBassin)
    }
    const handleStartDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
        setModalVisible(true)
        setModalAction(Delete)
        setDeleteCallback({delete: DeleteObject} )
    };
    function DeleteObject()
    {
        submitObject({id: RDRef.current?.data.id}, poolDetails?.id, DeactivateBassinCommand).then(async (event: any) =>
        {
            HandleSubmit(event)
        })

        setDetailStatus(false)
        setRefreshResource(Bassin)
    }

    async function HandleSubmit(event: any)
    {
        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status !== 200)
        {
            const response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }
    }

    return (<>
        <Grid container justifyContent="center" direction={"column"}>
            <Grid container className={"rm-container"} direction={"row"}>
                <Grid container>
                    <Typography variant="h4" marginRight={"auto"}>
                        Bassins
                    </Typography>
                </Grid>

                <Grid item xs={8} container alignItems={"stretch"} className={"containerspacing"}>

                    <div style={{
                        display: detailStatus
                                 ? "contents"
                                 : "none"
                    }}>
                        <Button className={"od-button"} onClick={ResetDetailStatus}>Back</Button>
                        {/*// @ts-ignore*/}
                        <ig-resource-detail lang="nl-NL" ref={RDRef} class={"od-table-resource ig-detail-remove-2rows ig-detail-remove-installatie-id"} style={IGStyle} resource-detail-id="BassinRD" resource-id={detailRecord}/>
                    </div>
                    <div style={{
                        display: detailStatus
                                 ? "none"
                                 : "contents"
                    }}>                     {/*// @ts-ignore*/}
                        <ig-resource-master lang="nl-NL" ref={RMRef} style={IGStyle} class={"od-table-master ig-columns ig-master-remove-installatie-id"} resource-master-id="BassinRM" dsl-filter={poolDSLFilter}/>
                    </div>

                </Grid>

                <Grid container item className={"button-container"} xs={3} marginLeft={1} justifyContent={"flex-start"}>

                    <Grid item xs={4}>
                        <Grid container direction="column" item>
                            <Button className={"od-button"} variant={"contained"} disabled={detailStatus} onClick={BassinToevoegen}>Bassin Toevoegen</Button>
                            <Button className={"od-button"} variant={"contained"} disabled={!detailStatus}  onClick={BassinBewerken}>Bassin Bewerken</Button>
                            <Button className={"od-button"} variant={"contained"} disabled={!detailStatus}  onClick={handleStartDelete}>Bassin Verwijderen</Button>
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    </>)
}

export default BassinBlock